// TokenStatus badges — small context-driven hints about the ACTIVE token, read
// from the manifest entry the provider resolves:
//   - LowLiquidityTag: a thin (low-liquidity) token (XRP/AVAX) shows a
//     "LOW LIQUIDITY" tag so a sparse dashboard isn't mistaken for missing data.
//   - LiveEdgeHint: a T-1 token (alts, until the poller extends) shows an "as of
//     yesterday · T-1" hint so the 24h window isn't mistaken for intraday.

import { useContext } from 'react';
import { Box } from '@mui/material';

import { tokens } from '../../../../styles/tokens';
import { OptionsFlowContext } from '../../../../providers/options-flow/options-flow-provider';

export const LowLiquidityTag = () => {
  const { activeToken } = useContext(OptionsFlowContext);
  if (activeToken?.liquidity !== 'low') return null;
  return (
    <Box
      sx={{
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '0.4px',
        textTransform: 'uppercase',
        color: tokens.flow.accent,
        border: `1px solid ${tokens.flow.accent}`,
        borderRadius: '4px',
        padding: '1px 6px',
        opacity: 0.9,
      }}
    >
      Low liquidity
    </Box>
  );
};

export const LiveEdgeHint = () => {
  const { activeToken } = useContext(OptionsFlowContext);
  if (activeToken?.live_edge !== 't-1') return null;
  return (
    <Box
      sx={{
        fontSize: 9,
        fontWeight: 600,
        letterSpacing: '0.4px',
        color: tokens.text.muted,
        fontFamily: 'ui-monospace, Menlo, Consolas, monospace',
      }}
    >
      as of yesterday · T-1
    </Box>
  );
};
